/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-04-01 10:01:30
 * @LastEditors: limin
 * @LastEditTime: 2021-04-13 10:14:21
 */
export const SOURCE = Object.freeze({
  //环境
  MINIAPP: 1, //小程序
  APP_ANDROID: 2, //安卓
  APP_IOS: 3, //iOS
  WECHAT_OFFICAL_WEB: 4, // 微信公众号
  // 与APP协议的通信类别
  COM_TYPE_LOGIN: 1, // 登录
  COM_TYPE_JUMP_APP: 3, // 跳转APP页面
  COM_TYPE_JUMP_MINI: 3, // 跳转小程序页面
  // 小程序APPID
  ALL_MINI_APP_ID: {
    'MY_SMART_STORE_PERSONAL': 'wx0df0f98cdb6625e6', // 我的智慧门店个人端小程序
  }
});
export default {}
